import Vue from 'vue';
// Core
import App from './App.vue';
//@ts-ignore
import i18n from '@app/plugins/i18n';
//@ts-ignore
import VueRamda from '@app/plugins/vue-ramda';
//@ts-ignore
import router from '@app/plugins/vue-router';
//@ts-ignore
import store from '@app/plugins/vuex';
//@ts-ignore
import wait from '@app/plugins/vue-wait';

import './registerServiceWorker';
import '@app/assets/styles/less/style.less';
import '@app/assets/styles/scss/style.scss';
import '@app/bootstrap/components';
import '@app/bootstrap/mixins';
import '@app/plugins/vue-error-page';
import '@app/plugins/vue-body-class';
import '@app/plugins/iview';
import '@app/plugins/vee-validate';
import '@app/plugins/vue-noty';
import '@app/plugins/vue-bootstrap';
import '@app/plugins/moment';
import '@app/plugins/vue-numeral';
import '@app/plugins/vue-clipboard2';
import '@app/plugins/vue-tel-input';
import '@app/plugins/vue-mask-input';
import '@app/plugins/vue-socket.io';
import '@app/plugins/vuescroll';
import '@app/plugins/chatra';

if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false;
  Vue.config.productionTip = false;
} else {
  Vue.config.devtools = true;
  Vue.config.productionTip = true;
}

Vue.prototype.$eventHub = new Vue();

new Vue({
  //@ts-ignore
  i18n,
  //@ts-ignore
  VueRamda,
  router,
  store,
  //@ts-ignore
  wait,
  render: (h) => h(App)
}).$mount('#app');
